module.exports = __webpack_public_path__ + "img/image-product-4-thumbnail.a2a7a04c.jpg";